<template>
  <div class="d-flex align-items-center profile-dropdown-wrapper">

    <span class="mr-3 pb-2">{{$auth.user().name}}</span>

    <va-dropdown
      class="profile-dropdown"
      v-model="isShown"
      boundary-body
      offset="0, 16px"
    >
      <!--<img slot="anchor" class="profile-section-avatar-container " src="static/logos/logo_evollu.png"/>-->
      <img slot="anchor" class="profile-section-avatar-container " src="static/icons/user-circle.svg"/>
      <div class="profile-dropdown__content pl-4 pr-4 pt-2 pb-2">
        <router-link
          v-for="option in options"
          :key="option.name"
          :to="{name: option.redirectTo}"
          class="profile-dropdown__item pt-1 pb-1 mt-2 mb-2"
        >
          {{ $t(`user.${option.name}`) }}
        </router-link>
      </div>
    </va-dropdown>
  </div>

</template>

<script>
export default {
  name: 'profile-section',
  data () {
    return {
      isShown: false,
    }
  },
  computed: {
    options: function() {
      const options = [
        {
          name: 'profile',
          redirectTo: 'profile',
        }
      ]
      if(this.$auth.user().entity_id === 1) {
        options.push({name: 'support_hub', redirectTo: 'support_hub'})
      }

      options.push({
        name: 'logout',
        redirectTo: 'logout',
      })

      return options
    }
  }
}
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  .profile-section-avatar-container {
    display: inline-block;
    width: 30px;
    height: 30px;
    background-color: white;
    border-radius: 50%;
    border: 2px solid $lighter-gray;
    overflow: hidden;

    img {
      height: 100%;
      width: 100%;
    }
  }

  &__anchor {
    color: $vue-green;
  }
  .va-dropdown-popper__anchor {
    display: flex;
    justify-content: flex-end;
  }
  &__content {
    background-color: $dropdown-background;
    box-shadow: $gray-box-shadow;
    border-radius: .5rem;
    width: 8rem;
  }
  &__item {
    display: block;
    color: $vue-darkest-blue;

    &:hover, &:active {
      color: $vue-green;
    }
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
